import { resources as maintenanceResources } from '@atlassian/eoc-maintenance/resources';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarEocTeamDashboard, {
	LazyTeamDashboardSidebar,
} from '@atlassian/jira-navigation-apps-sidebar-eoc-team-dashboard/src/async.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@atlassian/jira-operations-horizontal-nav/src/async.tsx';
import { opsTeamLayout } from '@atlassian/jira-ops-team-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { eocMaintenanceRoute } from '@atlassian/jira-router-routes-eoc-maintenance-routes/src/eocMaintenanceRoute.tsx';
import { LazyMaintenance, MaintenanceComponent } from './ui/MaintenanceComponent.tsx';

export const eocMaintenanceRouteEntry = createEntry(eocMaintenanceRoute, () => ({
	group: 'eoc',
	component: MaintenanceComponent,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		...maintenanceResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MENU_ID.PEOPLE,
		sidebar: AsyncSidebarEocTeamDashboard,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyMaintenance,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-eoc-maintenance-entries/src/eocMaintenanceRouteEntry.tsx',
			whichExportToUse: 'eocMaintenanceRouteEntry',
		},

		enabled: true,
	},
}));
